import React, { useState, useRef } from 'react';
import './Mixer.css';

const DB_MIN = -40;
const DB_MAX = 6;
const SLIDER_HEIGHT = 150;

const dbToY = (db) => ((DB_MAX - db) / (DB_MAX - DB_MIN)) * SLIDER_HEIGHT;

const MixerChannel = ({ label, value, onChange }) => {
  const trackRef = useRef(null);
  const draggingRef = useRef(false);

  const yToDb = (clientY) => {
    const rect = trackRef.current.getBoundingClientRect();
    const frac = Math.max(0, Math.min(1, (clientY - rect.top) / rect.height));
    const db = DB_MAX - frac * (DB_MAX - DB_MIN);
    return Math.round(db * 2) / 2; // 0.5 dB steps
  };

  const handlePointerDown = (e) => {
    e.currentTarget.setPointerCapture(e.pointerId);
    draggingRef.current = true;
    onChange(yToDb(e.clientY));
  };

  const handlePointerMove = (e) => {
    if (draggingRef.current) onChange(yToDb(e.clientY));
  };

  const handlePointerUp = () => {
    draggingRef.current = false;
  };

  const muted = value <= DB_MIN + 0.5;
  const readout = muted ? 'mute' : `${value > 0 ? '+' : ''}${value.toFixed(1)}`;

  return (
    <div className="mixer-channel">
      <div className={`mixer-readout${muted ? ' muted' : ''}${value !== 0 && !muted ? ' set' : ''}`}>
        {readout}
      </div>
      <div
        className="mixer-track"
        ref={trackRef}
        style={{ height: SLIDER_HEIGHT }}
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
        onPointerUp={handlePointerUp}
        onDoubleClick={() => onChange(0)}
        title="drag to adjust · double-click to reset"
      >
        <div className="mixer-track-line" />
        <div className="mixer-zero-tick" style={{ top: dbToY(0) }} />
        <div className="mixer-handle" style={{ top: dbToY(value) }} />
      </div>
      <div className="mixer-label">{label}</div>
    </div>
  );
};

/**
 * Mixer — bottom-right "mixer" toggle. Expands to minimal vertical dB
 * faders for the chop sampler and the backing drum loop.
 */
const Mixer = ({ channels }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="mixer">
      {open && (
        <div className="mixer-panel">
          {channels.map((c) => (
            <MixerChannel key={c.key} label={c.label} value={c.value} onChange={c.onChange} />
          ))}
        </div>
      )}
      <button
        type="button"
        className="mixer-toggle"
        onClick={(e) => { setOpen(!open); e.currentTarget.blur(); }}
      >
        mixer
      </button>
    </div>
  );
};

export default Mixer;
